import { capitalize } from '@material-ui/core';
import { Forms, SystemText } from 'e4shared';
import React from 'react';
import { apiPost } from 'services';

export const SnowflakeValidation = async (details, errors, user) => {
    const sf = JSON.parse(details || '{}');
    let valid = true;

    const st = (path, ...extra) => SystemText(`Admin/Integrations/Snowflake/Fields/${path}`, ...extra);

    const setError = (field, error, ...extras) => {
        errors.snowflakeDetails = errors.snowflakeDetails || {};
        errors.snowflakeDetails[field] = st(`${capitalize(field)}/Error/${error}`, ...extras);
        valid = false;
    };

    if (!sf.accountName) setError('accountName', 'Mandatory');
    if (!sf.username) setError('username', 'Mandatory');
    if (!sf.password) setError('password', 'Mandatory');
    if (!sf.role) setError('role', 'Mandatory');
    if (!sf.dbName) setError('dbName', 'Mandatory');
    if (!sf.schema) setError('schema', 'Mandatory');
    if (!sf.warehouse) setError('warehouse', 'Mandatory');

    if (Object.keys(errors?.snowflakeDetails || {}).length === 0) {
        const apiCall = apiPost(
            'integrations/snowflake-test',
            JSON.parse(details),
            user.guid,
            response => {
                if (response.error) {
                    setError('warehouse', 'Invalid', response.error);
                    valid = false;
                }
            },
            null,
            'POST',
            'json'
        );

        await apiCall;
    } else {
        return Object.keys(errors.snowflakeDetails).length === 0;
    }

    return valid;
};

export const Snowflake = ({ details, setDetails, errors }) => {
    const [accountName, setAccountName] = React.useState('');
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [role, setRole] = React.useState('');
    const [dbName, setDBName] = React.useState('');
    const [schema, setSchema] = React.useState('');
    const [warehouse, setWarehouse] = React.useState('');

    React.useEffect(() => {
        const sf = JSON.parse(details || '{}');
        setAccountName(sf.accountName);
        setUsername(sf.username);
        setPassword(sf.password);
        setRole(sf.role);
        setDBName(sf.dbName);
        setSchema(sf.schema);
        setWarehouse(sf.warehouse);
    }, []);

    React.useEffect(() => {
        const sf = {
            accountName,
            username,
            password,
            role,
            dbName,
            schema,
            warehouse,
        };

        setDetails(JSON.stringify(sf));
    }, [accountName, username, password, role, dbName, schema, warehouse]);

    const st = (path, ...extra) => SystemText(`Admin/Integrations/Snowflake/${path}`, ...extra);

    return (
        <div>
            <Forms.Text
                data-testid="snowflake-warehouse"
                mandatory
                error={errors?.warehouse}
                label={st('Fields/Warehouse/Label')}
                onChange={setWarehouse}
                value={warehouse}
            />
            <Forms.Text
                data-testid="snowflake-accountname"
                mandatory
                error={errors?.accountName}
                label={st('Fields/AccountName/Label')}
                onChange={setAccountName}
                value={accountName}
            />
            <Forms.Text
                data-testid="snowflake-username"
                mandatory
                error={errors?.username}
                label={st('Fields/Username/Label')}
                onChange={setUsername}
                value={username}
            />
            <Forms.Text
                data-testid="snowflake-password"
                mandatory
                error={errors?.password}
                type="password"
                label={st('Fields/Password/Label')}
                help={st('Fields/Password/Help')}
                onChange={setPassword}
                value={password}
            />
            <Forms.Text
                data-testid="snowflake-role"
                mandatory
                error={errors?.role}
                label={st('Fields/Role/Label')}
                onChange={setRole}
                value={role}
            />
            <Forms.Text
                data-testid="snowflake-dbname"
                mandatory
                error={errors?.dbName}
                label={st('Fields/DBName/Label')}
                onChange={setDBName}
                value={dbName}
            />
            <Forms.Text
                data-testid="snowflake-schema"
                mandatory
                error={errors?.schema}
                label={st('Fields/Schema/Label')}
                onChange={setSchema}
                value={schema}
            />
        </div>
    );
};

export default Snowflake;
